<template>
  <div>
    <fieldset>
      <div class="row">
        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showorder"
            >Show order button & order form:</label
          >
 
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showorder"
              v-model="form.showorder"
            />
         
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showorderstatus"
            >Show order status:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showorderstatus"
              v-model="form.showorderstatus"
            />
          
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showtracking"
            >Show account history:</label
          >
        
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showtracking"
              v-model="form.showtracking"
            />
         
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showchangepassword"
            >Show change password:</label
          >
        
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showchangepassword"
              v-model="form.showchangepassword"
            />
          
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="newsiteuser"
            >Redirect to "new" site:</label
          >
         
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="newsiteuser"
              v-model="form.newsiteuser"
            />
        
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="slotmachine"
            >Show slot machine:</label
          >
       
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="slotmachine"
              v-model="form.slotmachine"
            />
      
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  name: "UserOptions",
  data() {
    return {};
  },
  computed: {
    form() {
      return this.$store.state.manageClients.form;
    },
  },
};
</script>
<style></style>
